module.exports = __webpack_public_path__ + "static/pic4-6e5ff958994976345c5c06c3b3cb0e39.jpg";